import { getEntityStatusLabel } from '../entity-designer/utils/entity-designer.utils';

export const formatEntityRows = (rows) =>
  rows.map((row) => {
    const { SSE_STATUS } = row;
    return {
      ...row,
      STATUS: getEntityStatusLabel(SSE_STATUS),
    };
  });
